/*
 * @Author: wangshengqiang
 * @Date: 2022-02-27 17:35:58
 * @LastEditTime: 2022-03-21 16:42:58
 * @LastEditors: wangshengqiang
 * @Description:
 */
// import 'babel-polyfill';
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Loading } from 'zarm';
import { store, dispatch } from '@/store';
import { getQueryParam, isPreviewMode } from '@/utils';
import { queryGoodsTemplateConfig, queryGoodsDetail, getAllPreviewPageConfig } from '@/services';
import PreviewButton from '@/components/PreviewButton';
import ZaToast from '@/components/ZaToast';
import GRouter from './Router';
import IMessage from './IMessage';
import { getHistory } from '../history';
import PagePreView from './PagePreView';
import Gs from '../Gs';
export default function App({
  children
}) {
  // const { title, children } = props;
  // 获取json 配置数据
  const history = getHistory(Gs.config.basePath);
  Gs.history = history;

  const fetchConfigJson = async (promotionId, insureConfig) => {
    // this.setState({
    //   loading: true,
    // });
    Loading.show();
    let res = null;

    if (insureConfig) {
      res = await getAllPreviewPageConfig(insureConfig);
    } else {
      const formData = new FormData();
      formData.append('promotionId', promotionId);
      res = await queryGoodsTemplateConfig(formData);
    }

    Loading.hide();

    if (res.success) {
      dispatch({
        configJson: res.result,
        serverNowTime: res.serverNowTime,
        themes: res.result.themes
      });
    } else {
      ZaToast.show(res.message);
    }
  };

  const fetchGoodsDetail = async goodsId => {
    if (!goodsId) return;
    const {
      result,
      success
    } = await queryGoodsDetail({
      goodsId
    });

    if (success) {
      var _result$planList;

      const payload = {
        goodsDetail: result
      };

      if (((_result$planList = result.planList) === null || _result$planList === void 0 ? void 0 : _result$planList.length) === 1) {
        payload.PLAN_ID = result.planList[0].id;
      }

      dispatch(payload);
    }
  };

  useEffect(() => {
    const {
      promotionId,
      insureConfig,
      goodsId
    } = getQueryParam();

    if (promotionId || insureConfig) {
      fetchConfigJson(promotionId, insureConfig);
      fetchGoodsDetail(goodsId);
    }

    Gs.IM.postMessage({
      type: 'previewLoaded'
    });
  }, []);
  const isShow = isPreviewMode();
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(PreviewButton, null), /*#__PURE__*/React.createElement(IMessage, null), isShow && /*#__PURE__*/React.createElement(PagePreView, null), !isShow && /*#__PURE__*/React.createElement(GRouter, {
    history: history
  }));
}